import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Card,
  Flex,
  FormField,
  Page,
  TextInput,
} from '../../components';
import api from '../../utils/services';


const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

class NewForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        name: '',
      },
      errorMessage: null,
    };
  }

  handleChange = (event) => {
    this.setState({
      form: {
        [event.target.name]: event.target.value,
      },
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { form } = this.state;
    const { match: { params: { carrierId } } } = this.props;
    api.addForm({ ...form, carrierId })
      .then(() => {
        this.setState({
          errorMessage: null,
        });
        const { history } = this.props;
        history.push(`/carriers/${carrierId}/forms`);
      }).catch(() => {
        this.setState({
          errorMessage: 'An error occurred. Please try again.',
        });
      });
  }

  render() {
    const { form: { name }, errorMessage } = this.state;
    const { match: { params: { carrierId } } } = this.props;

    return (
      <Page
        breadcrumbs={[{ content: 'Forms', href: `/carriers/${carrierId}/forms` }]}
        title="Add Form"
      >
        <Card>
          <Card.Block>
            <form onSubmit={this.handleSubmit}>
              <FormField
                label="Name"
                input={TextInput}
                name="name"
                value={name}
                onChange={this.handleChange}
              />
              {errorMessage && 'An error occurred'}
              <Flex paddingTop="1em">
                <Flex.Item marginStart="auto">
                  <Button primary type="submit">Save</Button>
                </Flex.Item>
              </Flex>
            </form>
          </Card.Block>
        </Card>
      </Page>
    );
  }
}

NewForm.propTypes = propTypes;
export default withRouter(NewForm);
